<template>
    <b-container fluid>
        <b-row>
            <b-col lg="8" class="d-none d-sm-none d-md-none d-lg-block px-0">
                <b-carousel
                    id="carousel"
                    class="d-block img-fluid w-100"
                    style="text-shadow: 0px 0px 2px #000"
                    fade
                    :interval="5000"
                    indicators
                    img-width="1024"
                >
                    <b-carousel-slide caption="" img-alt="Perfil franqueador" :img-src="require('@/assets/bg1.png')">
                    </b-carousel-slide>
                </b-carousel>
            </b-col>
            <b-col md="12" lg="4" class="login">
                <div class="login-access">
                    <a class="logo">
                        <div class="logo-f360">
                            <img alt="Logo F360 Finanças" :src="require('@/assets/logo.png')">
                        </div>
                    </a>
                    <b-form v-show="loginShow" @submit="login" class="text-left form-login">
                        <b-form-row class="px-5">
                            <div class="col-md-12">
                                <b-form-group
                                    label-size="sm"
                                    label="Email:"
                                    label-for="email"
                                >
                                    <b-form-input
                                    id="email"
                                    type="email"
                                    v-model="form.Email"
                                    required
                                    placeholder="E-mail"
                                    size="lg" />
                                </b-form-group>

                                <b-form-group
                                    label-size="sm"
                                    label="Senha:"
                                    label-for="senha"
                                    class="position-relative"
                                >
                                    <b-form-input
                                    id="senha"
                                    type="password"
                                    v-model="form.Password"
                                    required
                                    placeholder="Senha"
                                    size="lg" />

                                    <a @click="forgottenPassword" size="lg" class="esqueceu-senha" type="submit">Esqueceu sua senha ?</a>
                                </b-form-group>

                                <!-- ✅ MENSAGEM DE ERRO DO RECAPTCHA -->
                                <b-alert 
                                    v-if="recaptchaError" 
                                    variant="danger" 
                                    show 
                                    dismissible
                                    @dismissed="recaptchaError = null"
                                    class="mb-3"
                                >
                                    {{ recaptchaError }}
                                </b-alert>

                                <b-button size="lg" class="btn-submit" type="submit" :disabled="loading">
                                    {{ loading ? 'Entrando...' : 'Entrar' }}
                                </b-button>
                                
                                <!-- Badge do reCAPTCHA v3 -->
                                <div v-if="recaptchaEnabled" class="recaptcha-badge-info">
                                    Protegido por reCAPTCHA
                                </div>
                            </div>
                        </b-form-row>
                    </b-form>

                    <b-form v-show="passwordForgotten" @submit="sendLinkPassword" class="text-left form-login">
                        <b-form-row class="px-5">
                            <div class="col-md-12">
                                <b-card-header
                                class="cardPassword">
                                    <p>Esqueci minha senha</p>
                                    <b-button-close @click="forgottenPasswordClose"
                                        class="btn-password-close"
                                    ></b-button-close>
                                </b-card-header>
                                <b-card
                                class=""
                                    border-variant="light"
                                >
                                <b-form-group
                                    label-size="sm"
                                    label="Email:"
                                    label-for="email-send"
                                >
                                    <b-form-input
                                    id="email-send"
                                    type="email"
                                    v-model="form.Email"
                                    required
                                    placeholder="E-mail"
                                    size="lg" />
                                </b-form-group>
                                <b-button @click="sendLinkPassword" size="lg" class="btn-submit" type="button">Enviar link para troca de senha</b-button>
                                </b-card>
                            </div>
                        </b-form-row>
                    </b-form>
                </div>
            </b-col>
        </b-row>
    </b-container>
</template>
<script>
import router from '@/router.js'
import { Loading } from 'element-ui'
import { mapMutations } from 'vuex';
export default {
    name: 'login',
    data(){
        return {
            form: {
                Email: null,
                Password: null,
                Token: 'colocar um token aqui',
                RecaptchaToken: null
            },
            passwordForgotten: false,
            loginShow: true,
            recaptchaError: null,
            loading: false,
            recaptchaEnabled: process.env.VUE_APP_RECAPTCHA_ENABLED === 'true',
            recaptchaSiteKey: process.env.VUE_APP_RECAPTCHA_SITE_KEY || ''
        }
    },
    created() {
        const urlParams = new URLSearchParams(window.location.search);
        const email = urlParams.get('email');
        const key = urlParams.get('key'); 
        if (email && key) {
            const url = new URL(window.location);
            url.search = '';
            window.history.pushState({}, '', url);
            let loadingInstance = Loading.service(Loading);

            this.axios.post(this.$urls.LOGIN_CAS, { email, key }).then(async (res) => {
                loadingInstance.close();
                this.loginSucess(res);
            }).catch(erro => this.handleServerError(erro, loadingInstance))
        }
    },
    mounted() {
        if (this.recaptchaEnabled) {
            if (!this.recaptchaSiteKey) {
                this.recaptchaError = 'Configuração de reCAPTCHA incompleta.';
                return;
            }
            this.loadRecaptchaScript();
            this.showRecaptchaBadge();
        }
    },
    beforeDestroy() {
        if (this.recaptchaEnabled) {
            this.hideRecaptchaBadge();
        }
    },
    computed: {
		user: {
            get() {
                return this.$store.state.user;
            },
            set(value) {
                this.$store.commit('updateUser', value);
            }
        }
	},
    methods: { 
        ...mapMutations(['setAcessosUser']),
        
        loadRecaptchaScript() {
            if (window.grecaptcha) {
                return;
            }

            const script = document.createElement('script');
            script.src = `https://www.google.com/recaptcha/api.js?render=${this.recaptchaSiteKey}`;
            script.async = true;
            script.defer = true;
            
            script.onerror = () => {
                this.recaptchaError = 'Falha ao carregar reCAPTCHA. Verifique sua conexão.';
            };

            document.head.appendChild(script);
        },

        async getRecaptchaToken(action = 'login') {
            if (!this.recaptchaEnabled) {
                return null;
            }

            return new Promise((resolve, reject) => {
                const timeout = setTimeout(() => {
                    reject(new Error('Timeout ao carregar reCAPTCHA'));
                }, 10000);

                const checkRecaptcha = () => {
                    if (window.grecaptcha && window.grecaptcha.ready) {
                        clearTimeout(timeout);
                        window.grecaptcha.ready(() => {
                            window.grecaptcha.execute(this.recaptchaSiteKey, { action })
                                .then(token => resolve(token))
                                .catch(error => reject(error));
                        });
                    } else {
                        setTimeout(checkRecaptcha, 100);
                    }
                };
                checkRecaptcha();
            });
        },

        async login(ev){
            ev.preventDefault()
            
            if (this.loading) return;
            
            this.loading = true;
            this.recaptchaError = null;

            try {
                // Obtém o token do reCAPTCHA v3
                if (this.recaptchaEnabled) {
                    this.form.RecaptchaToken = await this.getRecaptchaToken('login');
                }
            } catch (error) {
                this.recaptchaError = 'Erro ao validar reCAPTCHA. Tente novamente.';
                this.loading = false;
                return false;
            }

            const self = this
            const clearValues = () => {
                //self.form.Email = null
                self.form.Password = null
                self.form.RecaptchaToken = null;
            }

            let loadingInstance = Loading.service(Loading);
            this.axios.post(this.$urls.LOGIN, this.form).then(async (res) => {
                if (res.data.isCASSolicitation){
                    try {
                        loadingInstance.close();
                        this.loading = false;
                        clearValues();
                        window.location.href = `${process.env.VUE_APP_CAS_SSO}/auth?returnUrl=${res.data.returnUrl}&email=${res.data.email}&token=${res.data.token}`
                        return;
                    } catch (erro) {
                        this.handleServerError(erro, loadingInstance, clearValues)
                    }
                }
                loadingInstance.close()
                this.loading = false;
                this.loginSucess(res, clearValues);
            }).catch(erro => {
                this.loading = false;
                this.handleServerError(erro, loadingInstance, clearValues);
            })
            return false
        },

        handleServerError(erro, loadingInstance, clearValues){
            var objErro = Object.assign({}, erro).response;

            if (!objErro) {
                loadingInstance.close();
                clearValues;
            } else {
                const { status, data } = objErro;

                if (status == 401) {
                    localStorage.setItem("tokenTemp", data.token)
                    localStorage.setItem("loginToken", data.token)
                    localStorage.setItem("forcedLogin", data.isForcedLogin)
                    localStorage.setItem("isOnline", data.isOnline)

                    router.push({ path: '/desconectar', name: 'desconectar' });
                }

                loadingInstance.close();
                clearValues;
            }

            return;
        },

        loginSucess(res, clearValues){
            if(res.status == 200){
                localStorage.setItem('user',JSON.stringify({ ...res.data }));
                localStorage.setItem('accessToken',res.data.accessToken)
                localStorage.setItem('loginToken',res.data.loginToken)
                localStorage.setItem('isOnline',res.data.user.isOnline)

                this.setAcessosUser(res.data.claims);
                router.push({ path: '/', name: 'secure' })

                var getUser = JSON.parse(localStorage.getItem('user')) || ''

                this.user = res.data.user;
                
                this.trackingF360(this, 'Login', 'Dimensões personalizadas');

                this.$notify({
                    title: 'Seja Bem vindo !',
                    message: `${getUser.user.nome} 😃`,
                    position: 'bottom-right',
                    customClass: 'bg-dark'
                });
            }else{
                clearValues;
            }
        },

        forgottenPassword(){
            this.passwordForgotten = true;
            this.loginShow = false;
        },

        forgottenPasswordClose(){
            this.passwordForgotten = false;
            this.loginShow = true;
        },

        async sendLinkPassword(){
            let loadingInstance = Loading.service(Loading);
            const { Email } = this.form;
            const clearValuesForm = () => {
                this.form.Email = null
                this.form.Password = null
            }

            try {
               await this.axios.post(this.$urls.EMAIL,this.form);
               this.$notify({
                        title: 'E-mail enviado',
                        message: `Um E-mail de recuperação foi enviado para ${Email} 😃`,
                        position: 'top-right',
                        customClass: 'bg-dark'
                });
                this.forgottenPasswordClose();
            } catch (error) {
                this.$notify({
                        title: 'Houve um erro',
                        message: `Houve um erro ao enviar o E-mail`,
                        position: 'top-right',
                        customClass: 'bg-dark'
                });
            }finally{
                 loadingInstance.close();
                 clearValuesForm();
            }
        },

        showRecaptchaBadge() {
            this.$nextTick(() => {
                const badge = document.querySelector('.grecaptcha-badge');
                if (badge) {
                    badge.style.visibility = 'visible';
                }
            });
        },

        hideRecaptchaBadge() {
            const badge = document.querySelector('.grecaptcha-badge');
            if (badge) {
                badge.style.visibility = 'hidden';
            }
        }
    }
}
</script>
<style lang="scss" scoped>
    .login {
        background: #fff;
        min-height: 100vh;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        display: -webkit-flex;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        padding: 10px;
    }
    .login-access {
        text-align: center;
        margin: 0 auto;
        width: 100%;
    }
    .logo-f360 {
        margin: 8px;
        img {
            width: 50%;
            max-width: 250px;
            margin-bottom: 15px;
        }
    }
    .form-login{
        input, button{
            width: 100%;
        }
        label {
            color: #797979;
        }
        ::placeholder {
            color: #c7c6c6;
            font-size: 0.8em;
        }
        .btn-submit{
            width: 100%;
            background: #608db7 !important;
            border-color: #608db7 !important;
            &:hover{
                background: #5583af !important;
            }
        }
        .esqueceu-senha{
            background: #fff !important;
            color: #999;
            margin: 7px 0 0;
            text-align: left;
            transition: 0.2s;
            &:hover{
                color: #3a82c6 !important;
                background: #fff !important;
            }
        }
        .cardPassword{
            margin-top: 8%;
            display: -webkit-box;
            display: -ms-flexbox;
            display: flex;
            display: -webkit-flex;
            justify-content: space-between;
            height: 20%;

            .btn-password-close{
                width:5%;
                height: 5%;
            }
        }
    }
    .recaptcha-badge-info {
        text-align: center;
        font-size: 11px;
        color: #999;
        margin-top: 15px;
    }
    .cliqueaqui{
        background: #343944;
        padding: 1px 8px 6px;
        border-radius: 4px;
        text-decoration: none;
        color: #fff;
        margin: 0 4px;
        box-shadow: 1px 1px 0px 0px #fff;
        transition:0.2s;
        &:hover{
            background: #2b2b2b;
        }
    }
</style>

<!-- CSS Global para esconder o badge do reCAPTCHA por padrão -->
<style>
/* Esconde o badge do reCAPTCHA por padrão em todas as páginas */
.grecaptcha-badge {
    visibility: visible;
}
</style>